/* KIVI flipbook. Elke weergave is direct uit de drukbestanden gerenderd,
   zodat wat je op de site ziet exact is wat er gedrukt wordt. */
(function(){
  var B='https://cdn.shopify.com/s/files/1/0959/1059/2778/files/';
  var P={
    fv:B+'kivi-page-front-verdigris.png?v=1785962257',
    fl:B+'kivi-page-front-lava.png?v=1785962257',
    bv:B+'kivi-page-back-verdigris.png?v=1785962257',
    bl:B+'kivi-page-back-lava.png?v=1785962257',
    ins:B+'kivi-page-inside.png?v=1785962258',
    lin:B+'kivi-page-lined.png?v=1785962257'
  };

  /* w = paneelbreedte in px bij een hoogte van 422 px (B6 is 125 x 176 mm) */
  function page(src,w,alt,spread){
    return '<div class="pnl'+(spread?' pnl--spread':'')+'" style="width:'+w+'px">'+
      '<img src="'+src+'" alt="'+alt+'" style="width:100%;height:100%;display:block;object-fit:cover;border-radius:inherit">'+
    '</div>';
  }

  function set(c){
    var front = c==='V' ? P.fv : P.fl;
    var back  = c==='V' ? P.bv : P.bl;
    var name  = c==='V' ? 'Verdigris' : 'Lava';
    return [
      ['Voorkant',           page(front,300,'KIVI B6 voorkant '+name)],
      ['Binnenkant omslag',  page(P.ins,600,'KIVI B6 binnenkant omslag met liniaal en specificaties',true)],
      ["Gelijnde pagina's",  page(P.lin,300,"KIVI B6 gelijnde pagina, 7 mm")],
      ['Achterkant',         page(back,300,'KIVI B6 achterkant '+name)]
    ];
  }

  window.KIVIFLIP={V:set('V'),L:set('L')};
})();
